import React from 'react';
import {View} from 'react-native';
import {ISousTitre} from '../../../../data/types/interface/infoAssurance';
import {formsStyles} from '../../Inputs/formStyles';
import Label from '../../Label';
import {LibelleValeurs} from './LibelleValeurs';
interface Props {
  datas: ISousTitre[];
}
export const InfoSousTitre = ({datas}: Props) => {
  const form =
    datas &&
    datas.length > 0 &&
    datas.map((elt, i) => {
      return (
        <View key={i} style={formsStyles.formGroup}>
          <Label title={elt.libelle} type="secondTitle" />
          <LibelleValeurs datas={elt.valeurs} />
        </View>
      );
    });

  return <View>{form}</View>;
};
